import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'
import Header from '../inc/Header';

import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import magicshow2025 from "../images/Magic Show video.mp4";
import magicshow from "../images/video show.mp4";
import magicshowvideo from "../images/Magic Video New.mp4";
import magicshowmisaa_berhampore from "../images/Video 5.mp4";
import magicshow_berhampore from "../images/Video 4.mp4";
import magicshowvideo6 from "../images/Video 6.mp4"





function Magicshow2025() {
  const [setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showPerPage, setShowPerPage] = useState(258);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [searchTerm, setsearchTerm] = useState("");
  const [programs, setPrograms] = useState([])
  const navigate = useNavigate()

  const programsCollectionRef = collection(db, "Magic Show 2025");
  useEffect(() => {

    const getPrograms = async () => {
      const data = await getDocs(programsCollectionRef);
      setPrograms(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }

    getPrograms()
  }, [])
  return (

    <>
      <Header />
      <br />
      <br />

      <br />
      <br />





      <div className='bestberhamporeschoolmis'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/Gallery" style={{ color: "darkblue" }} >Back</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Magic Show 2025

                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-0">
        <div className="container">
          <h5 className='mb-2'>“Spreading Smiles through Magic!”</h5>
          <p><small>A wonderful magic show was conducted today, 7th November 2025, at Mary Immaculate School, Berhampore. The event, organised by Mary Immaculate School Alumni Association (M.I.S.A.A), was specially arranged for the little ones from U.K.G to Class 5 during school hours. The magician’s thrilling tricks filled the hall with laughter and excitement. The children’s happy and amazed faces reflected their joy. It was indeed an enthusiastic and successful event.</small></p>
        </div>
      </div>
      <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-4 mt-2">

              <Video Play loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshow2025} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-4 mt-2">

              <Video Play loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshow} type="video/webm" />
              </Video>
            </div>

            <div className="col-md-4 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshowvideo} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-4 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshowmisaa_berhampore} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-4 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshow_berhampore} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-4 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={magicshowvideo6} type="video/webm" />
              </Video>
            </div>

          </div>
        </div>
      </div>
      <div className="album py-0">

        <div className="container">

          <div className="row">
            {programs.filter((val) => {
              if (setsearchTerm === "") {
                return val;
              } else if (
                val.title.toLowerCase().includes(searchTerm.toLowerCase())




              ) {
                return val;
              }
            }).slice(pagination.start, pagination.end).map((magicshow) => {
              return (
                <div className="col-md-4 mt-3" >
                  <div className='card'>
                    <div className='hoverimage1'>
                      <img className="card-img-top image2" src={magicshow.img} alt={magicshow.title} />
                      <div className="overlay1"> {magicshow.title}</div>
                    </div>
                    <div className="card-body">
                      <center>
                        <h6 className="mt-" style={{ color: "darkBlue" }}> {magicshow.title}</h6>
                      </center>
                      <div className="d-flex justify-content-between align-items-center">
                      </div>
                    </div>

                  </div>
                </div>
              )
            })}
          </div>


        </div>
      </div>
      <br />

      <br />

    </>

  );
}

export default Magicshow2025;



